import { useCustom } from '@refinedev/core';
import { Card, Col, Row, Statistic, Typography } from 'antd';
import {
  CheckCircleOutlined,
  PlayCircleOutlined,
  SwapOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import type {
  ConversionStatsOut,
  ProgressionStatsOut,
  SessionStatsOut,
} from '@/api/generated/schemas';

export const ProgressKpiCards = () => {
  const { query: allTimeQuery } = useCustom<SessionStatsOut>({
    url: 'progress/sessions/stats',
    method: 'get',
  });
  const { query: recentQuery } = useCustom<SessionStatsOut>({
    url: 'progress/sessions/stats/recent',
    method: 'get',
    config: { query: { days: 30 } },
  });
  const { query: progressionQuery } = useCustom<ProgressionStatsOut>({
    url: 'progress/progressions/stats',
    method: 'get',
  });
  const { query: conversionQuery } = useCustom<ConversionStatsOut>({
    url: 'progress/sessions/stats/conversion',
    method: 'get',
  });

  const allTime = allTimeQuery.data?.data;
  const recent = recentQuery.data?.data;
  const progressions = progressionQuery.data?.data;
  const conversion = conversionQuery.data?.data;

  const completionPct = progressions
    ? Math.round(progressions.completion_rate * 100)
    : 0;
  const conversionPct = conversion
    ? Math.round(conversion.conversion_rate * 100)
    : 0;

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={12} lg={6}>
        <Card loading={allTimeQuery.isLoading}>
          <Statistic
            title="Sesje ogółem"
            value={allTime?.total_sessions ?? 0}
            prefix={<PlayCircleOutlined />}
            suffix={
              recent?.total_sessions != null ? (
                <Typography.Text
                  type="secondary"
                  style={{ fontSize: 12, marginLeft: 4 }}
                >
                  30d: +{recent.total_sessions}
                </Typography.Text>
              ) : undefined
            }
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card loading={allTimeQuery.isLoading}>
          <Statistic
            title="Czytelnicy"
            value={allTime?.unique_readers ?? 0}
            prefix={<TeamOutlined />}
            suffix={
              recent?.unique_readers != null ? (
                <Typography.Text
                  type="secondary"
                  style={{ fontSize: 12, marginLeft: 4 }}
                >
                  30d: +{recent.unique_readers}
                </Typography.Text>
              ) : undefined
            }
          />
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card loading={progressionQuery.isLoading}>
          <Statistic
            title="Wskaźnik ukończeń"
            value={completionPct}
            prefix={<CheckCircleOutlined />}
            suffix="%"
            valueStyle={{ color: '#3f8600' }}
          />
          {progressions?.completed != null && (
            <Typography.Text
              type="secondary"
              style={{ fontSize: 12, display: 'block', marginTop: 4 }}
            >
              {progressions.completed} ukończono
            </Typography.Text>
          )}
        </Card>
      </Col>

      <Col xs={24} sm={12} lg={6}>
        <Card loading={conversionQuery.isLoading}>
          <Statistic
            title="Konwersja preview→full"
            value={conversionPct}
            prefix={<SwapOutlined />}
            suffix="%"
            valueStyle={{ color: '#1677ff' }}
          />
          {conversion?.converting_readers != null && (
            <Typography.Text
              type="secondary"
              style={{ fontSize: 12, display: 'block', marginTop: 4 }}
            >
              {conversion.converting_readers} czytelników
            </Typography.Text>
          )}
        </Card>
      </Col>
    </Row>
  );
};
